// extracted by mini-css-extract-plugin
export default {"selectionWidget":"styles_selectionWidget__0+05F","chips":"styles_chips__L7gHf"};